import { Button, Col, Form, Input, Row, Spin, Switch } from 'antd';
import React, { useState, useContext } from 'react';
import styles from './styles.module.scss';
import {
  IsAdminContext,
  NumberOfEducationContext,
  UserEducationDataContext,
} from '../../../../../../../context';
import axiosInstance from '../../../../../../../axios_instance';
import { useParams } from 'react-router-dom';
import { errorHandling } from '../../../../../../../utils/helper';
import errorColumnMap from '../../../../../../../utils/error-message-mapping';
import { TextLengthValidator } from '../../../../../../../utils/validators';

const AddEducation: React.FC<{ setAddNew: any }> = ({
  setAddNew,
}: {
  setAddNew: any;
}) => {
  const [formData, setFormData] = useState<{ [key: string]: number }>({});
  const { userEducationData, setUserEducationData } = useContext(
    UserEducationDataContext
  );
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { numberOfEducation, setNumberOfEducation } = useContext(NumberOfEducationContext)
  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };

  const handleChangeResume = (value: any) => {
    setFormData({
      ...formData,
      ["show_in_resume"]: value,
    });
  };


  const handleSave = () => {
    setIsSubmitted(true)
    const requestBody: { [key: string]: any } = {};
    requestBody['degree_name'] = formData['degree_name'];
    requestBody['school_name'] = formData['school_name'];
    requestBody['passing_year'] = formData['passing_year'];
    requestBody['show_in_resume'] = 'show_in_resume' in formData ? formData['show_in_resume'] : true;
    requestBody['grade'] = formData['grade'];
    requestBody['status'] = 1;
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/educations';
      requestBody['profile_id'] = employeeId;
    } else {
      url = '/api/v1/profile/educations';
    }

    axiosInstance
      .post(url, requestBody)
      .then((response) => {
        const orderedEducations = response.data.order.map((educationId: number) =>
          response.data.educations.find((education: any) => education.education_id === educationId)
        ).filter((item: any) => item !== undefined);
        setUserEducationData(orderedEducations);
        setNumberOfEducation(orderedEducations.length);
        setAddNew(false);
      })
      .catch((error) => {
        errorHandling(error, setErrorMessage);
      })
      .finally(() => {
        setIsSubmitted(false)
      });
  };

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row className={styles.row}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", position: "absolute", bottom: "8px", right: "8px" }}><Switch defaultChecked onChange={handleChangeResume} /><span>Show in resume</span></div>
          <Col span={12}>
            <Row>
              <Form.Item
                name="degree_name"
                label=""
                rules={[TextLengthValidator]}
              >
                <p>
                  <span className={styles.title}>Degree Name : </span>
                  <Input
                    type="text"
                    className={styles.input}
                    name="degree_name"
                    onChange={handleChange}
                    placeholder="Write Degree Name Here"
                    style={{
                      borderBottom:
                        'degree_name' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'degree_name' in errorMessage
                  ? errorMessage['degree_name']
                  : ''}
              </p>
            </Row>
            <Row>
              <Form.Item
                name="school_name"
                label=""
                rules={[TextLengthValidator]}
              >
                <p>
                  <span className={styles.title}>Institute Name : </span>
                  <Input
                    type="text"
                    className={styles.input}
                    name="school_name"
                    onChange={handleChange}
                    placeholder="Write Institute Name Here"
                    style={{
                      borderBottom:
                        'school_name' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'school_name' in errorMessage
                  ? errorMessage['school_name']
                  : ''}
              </p>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Form.Item
                name="passing_year"
                label=""
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !value ||
                        (value > 1970 &&
                          value <= Number(new Date().getFullYear()))
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          'Input a valid year between 1970 and current year!'
                        )
                      );
                    },
                  }),
                ]}
              >
                <p>
                  <span className={styles.title}>Passing Year : </span>
                  <Input
                    className={styles['input-small']}
                    onChange={handleChange}
                    name="passing_year"
                    style={{
                      borderBottom:
                        'passing_year' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'passing_year' in errorMessage
                  ? errorMessage['passing_year']
                  : ''}
              </p>
            </Row>
            <Row>
              <Form.Item
                name="grade"
                label=""
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_: any, value: any) {
                      if (!value || value.length <= 30) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error('Ensure the value has at most 30 characters.')
                      );
                    },
                  }),
                ]}
              >
                <p>
                  <span className={styles.title}>Cgpa : </span>
                  <Input
                    className={styles['input-small']}
                    onChange={handleChange}
                    name="grade"
                    style={{
                      borderBottom:
                        'grade' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'grade' in errorMessage ? errorMessage['grade'] : ''}
              </p>
            </Row>
          </Col>
        </Row>
        <Row>
          {isSubmitted ? <Spin /> : <></>}
          <Form.Item style={{ float: 'right', marginLeft: 'auto' }}>
            <Button
              className={styles['save-button']}
              style={{ float: 'right', marginLeft: 'auto', marginRight: '0px' }}
              type="primary"
              htmlType="submit"
              disabled={
                !formData['degree_name'] ||
                !formData['school_name'] ||
                !formData['passing_year'] ||
                !formData['grade']
              }
            >
              Save
            </Button>
          </Form.Item>
          <Button
            className={styles['cancel-button']}
            style={{ marginRight: '0px' }}
            onClick={(e) => {
              setAddNew(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default AddEducation;
